import { useCallback, useState } from "react"
import { fetchQuery, graphql } from "relay-runtime"
import {
  useCallLinesServiceQuery,
  useCallLinesServiceQuery$data,
} from "@/modules/telephony/services/__generated__/useCallLinesServiceQuery.graphql.ts"
import { RelayEnvironment } from "@/relay-environment"

const callLineQuery = graphql`
  query useCallLinesServiceQuery($language: Language, $extensionId: String) {
    ch_telephoneLines(language: $language, extensionId: $extensionId) {
      id
      extensionIds
      key
      lineType
      telephoneLineTranslations {
        id
        language
        content
      }
    }
  }
`

const useCallLineQuery = (kidsLineCode: string) => {
  const [data, setData] = useState<useCallLinesServiceQuery$data | null>(null)
  const fetch = useCallback(() => {
    fetchQuery<useCallLinesServiceQuery>(RelayEnvironment, callLineQuery, {
      extensionId: kidsLineCode,
    }).subscribe({ next: setData })
  }, [kidsLineCode])

  return { data, fetch }
}

export { useCallLineQuery }

export type CallLine = useCallLinesServiceQuery$data

export type CallLineSource = useCallLinesServiceQuery$data["ch_telephoneLines"]

export type CallLineBase = NonNullable<CallLineSource>[number]

export type CallLineTranslations = NonNullable<CallLineBase>["telephoneLineTranslations"]

export type CallLineTranslation = NonNullable<CallLineTranslations>[number]
